import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import eventsReducer from './reducers/eventsReducer';
import uiReducer from './reducers/uiReducer';

// Combine all reducers
const rootReducer = combineReducers({
  events: eventsReducer,
  ui: uiReducer,
});

// Create store with middleware
const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

export default store;